<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Unmatch Report</li>
		</ol>

        <h1 class="page-header">Unmatch Report</h1>
        <hr>

         <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row ">
                <!-- <div class="col-lg-3 col-xs-12 " style="padding-left:0" >
                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-3 col-form-label">Status</label>
                        <div class="col-sm-9">
                            <select class="form-control" style="width:100%" v-model="filter.status">
                                <option value="" selected>All Status</option>
                                <option value="Success">Success</option>
                                <option value="Failed">Failed</option>
                            </select>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-4 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Date</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <date-range-picker id="dateTimeInput" v-model="dateRange" style="width:100%" >
                                <div slot="input" class="text-center" slot-scope="picker" opens="right" >
                                    <i class="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i> 
                                    {{ moment(dateRange.startDate).format("DD MMMM YYYY")}} - {{ moment(dateRange.endDate).format("DD MMMM YYYY")}}
                                    <b class="caret"></b>
                                    
                                </div>
                            </date-range-picker>
                            <label for="dateTimeInput" class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </label>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>

                <div class="col-lg-3 col-xs-12">
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Option</label>
                        <select class="form-control col-sm-9 col-xs-12 pl-0" v-model="filter.option">
                            <option value="1">No SAP Data</option>
                            <option value="0">No QRCode Matching</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-3 col-xs-12">
                    <input type="button" class="btn btn-primary float-right" style="width:100%" @click="search()" value="Search"></input>
                </div>
            </div>
        </panel>

        <!---Table Report Start-->
        <unmatchTable class="mt-4" v-if="filterReady"></unmatchTable>
    </div> 
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import moment from 'moment';
    import * as am4core from "@amcharts/amcharts4/core";

    // import child components
    import unmatchTable from './childComponents/unmatchTable'
    
    export default{
        data(){
            var startDate = moment().startOf('month')._d;
            var compareDate = {
                startDate :  new moment().subtract(1, 'months').date(1),
                endDate : new moment().date(0)
            }

            var filter = {
                start_date  : moment(startDate).format('YYYY-MM-DD') + " 08:00:00",
                end_date : new moment().add(1 ,'d').format('YYYY-MM-DD') + " ",
                status : "",
                option : 0
            }

            return{
                moment : moment,
                dateRange: {
                    startDate : startDate,
                    endDate : new moment()._d
                },
                format: moment.localeData().longDateFormat('L'),
                filter : filter,
                filterReady : false,
                searchButton : false,
            }
        },
        components : {
            DateRangePicker,
            unmatchTable
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
            this.$store.state.filterUrl = '';
        },
        watch : {
            dateRange : function(){
                let start_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                let end_date = moment(this.dateRange.endDate).add(1 ,'d').format('YYYY-MM-DD');
                this.filter.start_date = start_date;
                this.filter.end_date = end_date;
                this.initialiseFilter();
            },
            'filter.status' : function(){
                this.initialiseFilter();
            },
            'filter.option' : function(){
                this.initialiseFilter();
            }
        },
        mounted(){
            this.initialiseFilter();
        },
        methods : {
            initialiseFilter(){
                var keys = Object.keys(this.filter);
                let stringUrl = '?';
                var queryParams = this.filter;

                for(var i = 0 ; i < keys.length; i++){
                    if(keys[i] == 'status' && queryParams[keys[i]] == '')
                        continue;
                    
                    stringUrl += `${keys[i]}=${queryParams[keys[i]]}&`;
                    
                }
                this.$store.state.filterUrl = stringUrl;
                this.filterReady = true;
            },
            search(){
                if(this.searchButton)
                    return;

                this.searchButton = true;
                this.$store.state.updateData++;
                console.log(this.$store.state.updateData);
                this.searchButton = false;
            }
        }
    }
</script>

